import React, { useState } from "react";
import "./FeedbackAnswer.css"
import { AgreeLevel } from "../utils/comms";
import SelectOption from "./SelectOption"

function FeebackAnswer({ initAnswerFeedback, handleFeedbackUpdated }) {
    const [currentAnswerFeedback, setCurrentAnswerFeedback] = useState(initAnswerFeedback);

    const updateAnswerFeedback = (updates) => {
        const newAnswerFeedback = Object.assign(
            Object.create(Object.getPrototypeOf(currentAnswerFeedback)),
            currentAnswerFeedback,
            updates
        );
        setCurrentAnswerFeedback(newAnswerFeedback);
        handleFeedbackUpdated(newAnswerFeedback);
    };

    return (
        <div className="feedback-answer">

            <SelectOption
                promptText="The response contains all the necessary information. *"
                options={Object.values(AgreeLevel)}
                onOptionSelect={(option_text) => {
                    updateAnswerFeedback({completeness: option_text})
                }}
            />

            <SelectOption
                promptText="I was able to solve my problem / find what I was looking for in the response. *"
                options={Object.values(AgreeLevel)}
                onOptionSelect={(option_text) => {
                    updateAnswerFeedback({usefulness: option_text})
                }}
            />

            <SelectOption
                promptText="The response is related to my question, independent of other factors. *"
                options={Object.values(AgreeLevel)}
                onOptionSelect={(option_text) => {
                    updateAnswerFeedback({relatedness: option_text})
                }}
            />

            <SelectOption
                promptText="The response contains accurate information *"
                options={Object.values(AgreeLevel)}
                onOptionSelect={(option_text) => {
                    updateAnswerFeedback({accuracy: option_text})
                }}
            />

        </div>
    );
}

export default FeebackAnswer;

